module.exports = __webpack_public_path__ + "static/media/fabric_0002.1bb0cb77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/fabric_0002.jpg
// module id = 628
// module chunks = 0